import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {autobind} from 'core-decorators';
import {connect} from 'store';
import {printTranscript} from 'store/ui/actions';

export class Print extends Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        print: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.loading !== this.props.print
            || nextProps.print !== this.props.print;
    }

    @autobind
    handleClick() {
        if (!this.props.loading) this.props.print();
    }

    render() {
        return (
            <div className='cielo24-vwrap-print'>
                <button
                    type='button'
                    className='cielo24-vwrap-toggle'
                    title={i18next.t('Print')}
                    aria-label={i18next.t('Print')}
                    onClick={this.handleClick}
                >
                    {this.props.loading ? (
                        <span aria-hidden={true} className='cielo24-vwrap-spinner' />
                    ) : (
                        <i aria-hidden={true} className='cielo24-vwrap-icon cielo24-vwrap-icon-print' />
                    )}
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.ui.get('printLoading'),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({print: printTranscript}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Print);



// WEBPACK FOOTER //
// ./scripts/components/footer/print.js